import '@/app/app.css';
import './account.css';

import '@/app/app';
import '@/layouts/main/main.js';
import {FormCalendar} from '@/features/form-calendar/form-calendar';
import {ProductBlock} from '@/features/product-block/product-block';

window.app = window.app || {};

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-sticky').forEach((element) => {
		new app.Sticky(element, {
			breakpoint: vars.breakpoint.laptop,
			indentTop: 0,
			indentBottom: 20,
			top: 80,
			bottom: 20,
		});
	});

	new FormCalendar(document.querySelector('.js-account-calendar'));
	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));
});
